import useMediaQuery from '../hooks/useMediaQuery';
import { motion } from 'framer-motion';
import AnchorLink from "react-anchor-link-smooth-scroll";
import SocialMedia from './SocialMedia';
import Type from '../effects/Type';

const LandingPage = ({ setSelectedPage }) => {
    const isAboveLarge = useMediaQuery("(min-width: 1060px)");

    return (
        // section is divided into two parts one is for image and other is for greeting message
        <section id="home" className='pb-5 md:flex md:justify-between md:items-center md:h-full gap-16 py-10'>

            {/* image part of the landing page */}
            <div className='basis-4/5 z-10 shadow-md rounded-lg mt-16 md:mt-32 flex justify-center md:order-2'>
                {/* profile image part of the landing page */}
                {
                    isAboveLarge ? (
                        <div className="bg-[rgba(32, 4, 67, 0.513)] rounded-2xl relative flex flex-col items-center w-full max-w-[400px] md:max-w-[500px]">
                            <img
                                alt="profile"
                                className="relative z-10 rounded-full hover:filter w-full opacity-90 saturate-200 transition duration-500 max-w-[400px] md:max-w-[350px] bg-white"
                                src="/ranvijay_profile.png"
                            />
                            <div
                                className="text-center bg-gradient-to-r from-purple-600 to-blue-600 text-white font-bold py-3 px-6 m-5 rounded-xl shadow-lg transition-all duration-300 hover:shadow-xl hover:bg-gradient-to-r hover:from-purple-700 hover:to-blue-700 hover:scale-105 flex items-center justify-center gap-2"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                    />
                                </svg>
                                <a
                                    target="_blank"
                                    href="https://drive.google.com/file/d/1JGNfDs9p8o4aVZ_a3S685CRICiN3oIAy/view?usp=sharing"
                                    className="inline-block"
                                    rel="noopener noreferrer"
                                >
                                    View Resume
                                </a>
                            </div>
                        </div>
                    ) : (
                        <div className="bg-[rgba(32, 4, 67, 0.513)] rounded-2xl relative flex flex-col items-center">
                            <img
                                alt="profile"
                                className="ml-4 mr-4 rounded-full bg-gradient-to-r to-slate-700 relative z-10 hover:filter saturate-200 transition duration-500 w-full max-w-[250px]"
                                src="/ranvijay_profile.png"
                            />
                            <div
                                className="text-center bg-gradient-to-r from-purple-600 to-blue-600 text-white font-bold py-3 px-6 m-5 rounded-xl shadow-lg transition-all duration-300 hover:shadow-xl hover:bg-gradient-to-r hover:from-purple-700 hover:to-blue-700 hover:scale-105 flex items-center justify-center gap-2"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                    />
                                </svg>
                                <a
                                    target="_blank"
                                    href="https://drive.google.com/file/d/1JGNfDs9p8o4aVZ_a3S685CRICiN3oIAy/view?usp=sharing"
                                    className="inline-block"
                                    rel="noopener noreferrer"
                                >
                                    View Resume
                                </a>
                            </div>
                        </div>
                    )
                }
            </div>

            {/* Greeting message part of the landing page */}
            <div className='z-30 basis-2/5 mt-5 md:mt-32'>
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 1 }}
                    className=''
                    variants={{
                        hidden: { opacity: 0, x: -50 },
                        visible: { opacity: 1, x: 0 },
                    }}
                >
                    <p className='text-3xl font-playfair z-10 text-center md:text-start md:text-5xl'>
                        Ranvijay {" "}
                        <span
                            className="xs:relative xs:text- xs:font-bold z-20 text-purple-300 before:absolute before:-left-[25px] before:-top-[70px] before:z-[-1]"
                        >
                            Kumar
                        </span>
                    </p>
                    <h3 className='text-1xl mt-5 mb-5 text-sm text-center md:text-start'>
                        <Type />
                    </h3>
                    <p className="mt-2 mb-7 bg-[rgba(45, 17, 79, 0.429)] text-smd text-center md:text-start">
                        <br />
                        I'm Ranvijay Kumar, a Computer Science Engineer from the Indian Institute of Technology, Nagpur.
                        Welcome! Here, you'll find insights into my journey, projects, and passions.
                        From pioneering tech solutions to tackling complex challenges, this space offers a window into my work and the innovation that drives me.
                    </p>
                    <p className="mt-4 mb-7 text-sm text-center md:text-start">
                    </p>
                </motion.div>

                <motion.div
                    className='flex justify-center mt-5 md:justify-start'
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ delay: 0.5, ration: 2 }}
                    variants={{
                        hidden: { opacity: 0, x: -50 },
                        visible: { opacity: 1, x: 0 },
                    }}
                >
                    <a
                        className="bg-gradient-to-br from-purple-800 via-purple-800 to-violet-800 text-deep-blue rounded-sm py-3 px-7 font-semibold mr-2 hover:bg-blue hover:text-white hover:scale-105 transition duration-500 hover:shadow-lg hover:shadow-purple-500"
                        onClick={() => setSelectedPage("contact")}
                        href="https://www.linkedin.com/in/ranvijay-kumar-825457255/"
                    >
                        Hire Me
                    </a>
                    <AnchorLink
                        className='rounded-r-md bg-gradient-to-br from-purple-800 via-purple-800 to-violet-800 py-0.5 pr-0.5'
                        onClick={() => setSelectedPage("contact")}
                        href="#contact"
                    >
                        <div className='bg-purple-800 hover:text-white transition duration-500 w-full h-full flex items-center justify-center px-10 font-semibold text-black hover:shadow-lg hover:shadow-purple-500'>
                            Contact Me
                        </div>
                    </AnchorLink>
                </motion.div>
                <motion.div
                    className="flex mt-5 justify-center md:justify-start"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ delay: 0.4, duration: 0.5 }}
                    variants={{
                        hidden: { opacity: 0, x: -50 },
                        visible: { opacity: 1, x: 0 },
                    }}
                >
                    <SocialMedia />
                </motion.div>
            </div>
        </section>
    )
}

export default LandingPage;
